import { render } from "./Wms.vue?vue&type=template&id=7972c3e1&ts=true"
import script from "./Wms.vue?vue&type=script&lang=ts"
export * from "./Wms.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__